module.exports = __webpack_public_path__ + "img/27f58b0.webp";